<input #fileInput type="file" [attr.multiple]="multiple ? '' : null" [attr.accept]="accept" [attr.capture]="capture" (change)="handleFiles($event)">
<ng-content></ng-content>

<ng-template #uploadSheet>
    <app-upload-item *ngFor="let u of uploads" [file]="u" (onCancel)="cancelUpload($event)"></app-upload-item>
</ng-template>